// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".i7PA2wUIej2pOnwvuQAl8w\\=\\={display:flex}.i7PA2wUIej2pOnwvuQAl8w\\=\\=>span{width:32px}.i7PA2wUIej2pOnwvuQAl8w\\=\\=>span>div{margin-top:8px}", "",{"version":3,"sources":["webpack://./components/layouts/Header/Beamer/BeamerWidget.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CAEA,iCACE,UAAA,CAEA,qCACE,cAAA","sourcesContent":[".beamerWrapper {\n  display: flex;\n\n  > span {\n    width: 32px;\n\n    > div {\n      margin-top: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"beamerWrapper": "i7PA2wUIej2pOnwvuQAl8w=="
};
export default ___CSS_LOADER_EXPORT___;
